
import React, { useState } from "react";


import "../css-coding/gallery.css";
import smd1 from "../assets/smd1.png";
import smd2 from "../assets/smd2.png";
import smd3 from "../assets/smd3.png";
import smd4 from "../assets/smd4.png";
import smd5 from "../assets/smd5.png";
import smd6 from "../assets/smd6.jpg";
import smd7 from "../assets/smd7.jpg";
import smd8 from "../assets/smd8.jpg";

import yt1 from "../assets/yt1.jpg";
import yt2 from "../assets/yt2.png";
import yt3 from "../assets/yt3.png";
import yt4 from "../assets/yt4.png";
import yt5 from "../assets/yt5.png";
import yt6 from "../assets/yt6.png";
import yt7 from "../assets/yt7.jpg";
import yt8 from "../assets/yt8.jpg";
import yt9 from "../assets/yt9.png";


import ig1 from "../assets/ig1.png";
import ig2 from "../assets/ig2.png";
import ig3 from "../assets/ig3.png";
import ig4 from "../assets/ig4.png";
import ig5 from "../assets/ig5.png";
import ig6 from "../assets/ig6.png";
import ig7 from "../assets/ig7.png";
import ig8 from "../assets/ig8.png";
import ig9 from "../assets/ig9.jpg";
import ig10 from "../assets/ig10.jpg";

import bl1 from "../assets/bl1.jpeg";
import bl2 from "../assets/bl2.jpeg";
import bl3 from "../assets/bl3.jpeg";
import bl4 from "../assets/bl4.jpg";
import bl5 from "../assets/bl5.png";

import ad1 from "../assets/ad1.jpg";
import ad2 from "../assets/ad2.png";
import ad3 from "../assets/ad3.png";
import ad4 from "../assets/ad4.png";
import ad5 from "../assets/ad5.PNG";
import ad6 from "../assets/ad6.png";
import ad7 from "../assets/ad7.jpg";
import ad8 from "../assets/ad8.jpeg";



const socialMediaDesigns = [
  { id: 1, src: smd1 },
  { id: 2, src: smd2 },
  { id: 3, src: smd3 },
  { id: 4, src: smd4 },
  { id: 5, src: smd5 },
  { id: 6, src: smd6 },
  { id: 7, src: smd7 },
  { id: 8, src: smd8 },
];

const youtubeThumbnails = [
  { id: 1, src: yt1 },
  { id: 2, src: yt2 },
  { id: 3, src: yt3 },
  { id: 4, src: yt4 },
  { id: 5, src: yt5 },
  { id: 6, src: yt6 },
  { id: 7, src: yt7 },
  { id: 8, src: yt8 },
  { id: 9, src: yt9 },
];

const adCampaignPosters = [
  { id: 1, src: ad1},
  { id: 2, src:  ad2 },
  { id: 3, src:  ad3 },
  { id: 4, src:  ad4 },
{ id: 5, src:  ad5 },
{ id: 6, src:  ad6 },
{ id: 7, src:  ad7 },
  { id: 8, src:  ad8 },
];

const brandingLogos = [
  { id: 1, src: bl1 },
  { id: 2, src: bl2 },
  { id: 3, src: bl3 },
  { id: 4, src: bl4 },
    { id: 5, src: bl5 },
];

const instaCovers = [
  { id: 1, src: ig1 },
  { id: 2, src:  ig2},
  { id: 3, src:  ig3 },
  { id: 4, src:  ig4 },
  { id: 5, src:  ig5 },
  { id: 6, src:  ig6 },
  { id: 7, src:  ig7 },
  { id: 8, src:  ig8 },
  { id: 9, src:  ig9 },
  { id: 10, src: ig10 },
];

// ✅ Updated: Now each gallery-section gets a unique class name
const GalleryGrid = ({ title, images , setSelectedImage }) => {
  const slug = title
    .replace(/\s+/g, "-")           // spaces → hyphens
    .replace(/[^a-zA-Z0-9-]/g, "")  // remove special characters
    .toLowerCase();

  return (
    <div className={`gallery-section ${slug}`}>
      <h3 className="gallery-title">{title}</h3>
      <div className="gallery-grid">
        <div className="image-grid">
          {images.map((item) => (
            <div
              key={item.id}
              className={`image-box ${item.src ? "has-image" : ""}`}
              onClick={() => setSelectedImage(item.src)}
            >
              {item.src ? (
                <img src={item.src} alt={`Design ${item.id}`} />
              ) : (
                <div className="placeholder" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};




const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  
  return (
    <div className="gallery-wrapper">
      <GalleryGrid title="Social Media Designs" images={socialMediaDesigns} setSelectedImage={setSelectedImage} />
      <GalleryGrid title="Youtube Thumbnails" images={youtubeThumbnails} setSelectedImage={setSelectedImage} />
      <GalleryGrid title="Ad Campaign Posters" images={adCampaignPosters} setSelectedImage={setSelectedImage} />
      <GalleryGrid title="Branding Logos" images={brandingLogos} setSelectedImage={setSelectedImage} />
      <GalleryGrid title="Instagram Covers" images={instaCovers} setSelectedImage={setSelectedImage} />

      {selectedImage && (
  <div className="lightbox" onClick={() => setSelectedImage(null)}>
    <img src={selectedImage} alt="Enlarged view" className="lightbox-img" />
  </div>
)}
    </div>
  );
};

export default GallerySection;
